export default __webpack_public_path__ + "static/bg-catalog-8998d5c6deffebb190d3df0bffed7c81.png";